import { render, staticRenderFns } from "./AnnotationsContainer.vue?vue&type=template&id=4ab471e5&scoped=true"
import script from "./AnnotationsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab471e5",
  null
  
)

export default component.exports